export default "__VITE_ASSET__DJHBV18H__"